import { Component, OnInit } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { AutomationVariableMenuComponent } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.component';
import { insertVariable } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';

export const ASSIGNED_SALESPERSON = 'assigned salesperson';
export const COMPANY = 'company';

@Component({
  selector: 'automata-send-inbox-message-panel',
  templateUrl: './send-inbox-message-panel.component.html',
  styleUrls: ['./send-inbox-message-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    AutomationVariableMenuComponent,
  ],
})
export class SendInboxMessagePanelComponent extends CommonActionPanelComponent implements OnInit {
  messageBodyControl: UntypedFormControl = new FormControl('', [Validators.required]);

  assignedSalesperson = ASSIGNED_SALESPERSON;
  companyOnly = COMPANY;
  messageFromControl: UntypedFormControl = new UntypedFormControl('');

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.messageBodyControl.setValue(jsonData.message_body);
    this.messageFromControl.setValue(jsonData.message_from);

    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    jsonData.message_body = this.messageBodyControl.value;
    jsonData.message_from = this.messageFromControl.value;

    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.messageBodyControl, this.messageFromControl];
  }

  isFormValid(): boolean {
    return this.messageBodyControl.valid && this.messageFromControl.valid;
  }

  insertVariable(elementID: string, control: AbstractControl, variable: string): void {
    insertVariable(elementID, control, variable);
  }
}
